// extracted by mini-css-extract-plugin
export default {"loadingScreen":"loading_loadingScreen__75QIJ","loadingSpinner":"loading_loadingSpinner__KfZM9","spin":"loading_spin__X9Z3Q"};